import {AfterViewInit, Directive, ElementRef, Renderer2} from '@angular/core';

@Directive({
	selector: '[auto-text-align]',
	standalone: true,
})
export class AutoTextAlignDirective implements AfterViewInit {
	constructor(
		private el: ElementRef,
		private renderer: Renderer2,
	) {}

	ngAfterViewInit() {
		this.setTextAlign();
	}

	setTextAlign() {
		if (this.isHebrew(this.el.nativeElement.innerText)) {
			this.renderer.setStyle(this.el.nativeElement, 'text-align', 'right');
		} else {
			this.renderer.setStyle(this.el.nativeElement, 'text-align', 'left');
		}
	}

	private isHebrew(text: string): boolean {
		const hebrewRegex = /[\u0590-\u05FF]/;
		return hebrewRegex.test(text);
	}
}
